export const publishers = [
  {
    id: 4,
    category_id: "The Christian Science Monitor",
    categoryName_chr: "The Christian Science Monitor",
    sortOrder_num: 3,
    description_chr: [
      "The Christian Science Monitor (CSM) is a nonprofit international news organization that publishes content daily online and in a weekly print edition. Despite its name and ownership by a church, it is not primarily a religious publication and is widely regarded as a reputable and high-quality news source with minimal bias.",
    ],
    note_chr: null,
    isHidden_ysn: false,
  },
  {
    id: 10,
    category_id: "Financial News",
    categoryName_chr: "Financial News",
    sortOrder_num: 2,
    description_chr: [
      "",
    ],
    note_chr: null,
    isHidden_ysn: false,
  },
  {
    id: 2,
    category_id: "Business Insider",
    categoryName_chr: "Business Insider",
    sortOrder_num: 1,
    description_chr: [
      "Business Insider is an American financial and business news website known for its coverage of business, technology, markets, and lifestyle topics, offering original reporting and analysis for a global audience.",
    ],
    note_chr: null,
    isHidden_ysn: false,
  },
  {
    id: 3,
    category_id: "Foreign Policy",
    categoryName_chr: "Foreign Policy",
    sortOrder_num: 1,
    description_chr: [
      "Foreign Policy is an American magazine focused on global affairs, current events, and international policy. It was created to provide alternative perspectives on American foreign policy and is known for explaining Washington to the world and the world to Americans.",
    ],
    note_chr: null,
    isHidden_ysn: false,
  },
  {
    id: 5,
    category_id: "MIT Technology Review",
    categoryName_chr: "MIT Technology Review",
    sortOrder_num: 3,
    description_chr: [
      "MIT Technology Review is a bimonthly magazine owned entirely by the Massachusetts Institute of Technology (MIT). It focuses on new technologies and their commercial, social, and political impacts, covering breakthroughs and current issues in fields like biotechnology, nanotechnology, computing, energy, and telecommunications.",
    ],
    note_chr: null,
    isHidden_ysn: false,
  },
  {
    id: 5,
    category_id: "The Nation",
    categoryName_chr: "The Nation",
    sortOrder_num: 3,
    description_chr: [
      "The Nation is the oldest continuously published weekly magazine in the United States, established in 1865. It provides progressive political analysis, opinion, and investigative journalism, covering topics such as politics, social justice, culture, and international affairs from a distinctly liberal perspective.",
    ],
    note_chr: null,
    isHidden_ysn: false,
  },
  {
    id: 6,
    category_id: "The New Republic",
    categoryName_chr: "The New Republic",
    sortOrder_num: 1,
    description_chr: [
      "The New Republic is an American magazine focused on politics, culture, and the arts from a left-leaning perspective. Founded in 1914, it has long been considered an influential journal of opinion in the United States.",
    ],
    note_chr: null,
    isHidden_ysn: false,
  },
  {
    id: 8,
    category_id: "Project Syndicate",
    categoryName_chr: "Project Syndicate",
    sortOrder_num: 3,
    description_chr: [
      "Project Syndicate is an international non-profit media organization that publishes and syndicates commentaries and analysis on a variety of global topics. It provides opinion pieces, videos, and podcasts on current affairs relating to economics, politics, sustainability, innovation, health, and development.",
    ],
    note_chr: null,
    isHidden_ysn: false,
  },
  {
    id: 1,
    category_id: "The Washington Post",
    categoryName_chr: "The Washington Post",
    sortOrder_num: 1,
    description_chr: [
      "The Washington Post is an American daily newspaper published in Washington, D.C. Founded in 1877, it is the most widely circulated newspaper in the Washington metropolitan area and has a large national audience. It is renowned for its political reporting, particularly on the White House, Congress, and other aspects of the U.S. government.",
    ],
    note_chr: null,
    isHidden_ysn: false,
  },
  {
    id: 7,
    category_id: "The Washington Times",
    categoryName_chr: "The Washington Times",
    sortOrder_num: 3,
    description_chr: [
      "The Washington Times is a daily newspaper published in Washington, D.C. It was founded in 1982 to be a conservative alternative to The Washington Post and is known for its conservative political stance, often supporting the policies of the Republican Party.",
    ],
    note_chr: null,
    isHidden_ysn: false,
  },
];